import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {showSwal} from '../../../../ui-kit'
import {getPendingLegalTina, submitLegalTina} from './core/_requests'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {useNavigate, useParams} from 'react-router-dom'
import {LegalTinaDetail} from './core/_models'
import './LegalTinaReviewPage.scss'
import LegalTinaPendingForm from './components/LegalTinaPendingForm'
import LegalTinaComparisonForm from './components/LegalTinaComparisonForm'



const LegalTinaReviewPage: FC = () => {
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const {idLegal} = useParams()
  const [isLoadingLegal, setIsLoadingLegal] = useState(false)
  const [isLoadingButton, setIsLoadingButton] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)

  const initialLegal: LegalTinaDetail = {
    unique_code: '',
    heading: '',
    description: '',
    level: '',
    divider: false,
    upcoming_flag: false,
    sub_issue: false,
    parent_id: '',
    recommended_keyword: '',
  }

  const [legalPending, setLegalPending] = useState<LegalTinaDetail>(initialLegal)
  const [legalOrigin, setLegalOrigin] = useState<LegalTinaDetail>(initialLegal)

  const isDifferent = (originVal: any, newVal: any) => {
    if (!originVal && !newVal) return false
    return String(originVal || '').trim() !== String(newVal || '').trim()
  }

  const fetchPendingLegal = async () => {
    try {
      setIsLoadingLegal(true)

      const detailRes = await getPendingLegalTina(axiosPrivate, {idLegal})
      const detailResdata = detailRes.data.data

      if (detailResdata && detailResdata.legal_pending_review) {
        const pending = detailResdata.legal_pending_review
        const origin = detailResdata.legal_origin ? detailResdata.legal_origin[0] : []

        setLegalPending((prev) => ({...prev, ...pending}))
        if (origin) {
          setLegalOrigin((prev) => ({...prev, ...origin}))
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingLegal(false)
    }
  }

  useEffect(() => {
    fetchPendingLegal()
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const {name, value, type} = e.target as HTMLInputElement
    const checked = (e.target as HTMLInputElement).checked

    setLegalPending((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }))
  }

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const {name, value} = e.target
    setLegalPending((prev) => ({
      ...prev,
      [name]: value === '1' ? 1 : value === '0' ? 0 : value === '' ? null : value,
    }))
  }

  const validateRequiredFields = () => {
    const requiredFields = ['unique_code', 'heading', 'level']

    const isValid = requiredFields.every((key) => {
      const val = (legalPending as any)[key]
      return val !== undefined && val !== null && String(val).trim() !== ''
    })

    setIsFormValid(isValid)
  }

  useEffect(() => {
    validateRequiredFields()
  }, [legalPending])

  const handleSubmit = () => {
    const payload = {...legalPending}

    // Parse parent_id to null if empty
    if (payload.parent_id === '' || payload.parent_id === undefined) {
      payload.parent_id = null
    }

    payload['divider'] = payload['divider'] == 1 ? true : false
    payload['upcoming_flag'] = payload['upcoming_flag'] == 1 ? true : false
    payload['sub_issue'] = payload['sub_issue'] == 1 ? true : false

    delete payload['created_at']
    delete payload['deleted_at']

    showSwal({
      title: 'Are you sure you want to submit this review?',
      icon: 'question',
    }).then((result) => {
      if (!result.isConfirmed) return // exit if user cancels

      setIsLoadingButton(true)

      submitLegalTina(axiosPrivate, idLegal, payload)
        .then((res) => {
          if (res.status === 200) {
            showSwal('Legal TINA reviewed', undefined, 'success').then(() => {
              navigate('/legal-tina')
            })
          }
        })
        .catch((err) => {
          console.error(err)
          showSwal('Error', 'Failed to submit review', 'error')
        })
        .finally(() => {
          setIsLoadingButton(false)
        })
    })
  }

  const handleCancel = () => {
    showSwal({
      title: 'Are you sure you want to cancel?',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })
  }

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'Decision Support System',
            path: '',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'Legal',
            path: 'dss/legal',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Review Legal TINA
      </PageTitle>
      <div className='LegalTinaReviewPage'>
        <div className='row'>
          {legalOrigin.id != null ? (
            <div className='col-12'>
              <LegalTinaComparisonForm
                isLoadingLegal={isLoadingLegal}
                legalOrigin={legalOrigin}
                legalPending={legalPending}
                isDifferent={isDifferent}
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
                isLoadingButton={isLoadingButton}
                isFormValid={isFormValid}
              />
            </div>
          ) : (
            <div className='col-12'>
              <LegalTinaPendingForm
                isLoadingLegal={isLoadingLegal}
                legalOrigin={legalOrigin}
                legalPending={legalPending}
                isDifferent={isDifferent}
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
                isLoadingButton={isLoadingButton}
                isFormValid={isFormValid}
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default LegalTinaReviewPage
